"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenderUtils = void 0;
var _lodash = require("lodash");
var Sex = {
  Male: 1,
  Female: 2
};
var getLabel = function getLabel(id) {
  return (0, _lodash.findKey)(Sex, function (value) {
    return value === (0, _lodash.toNumber)(id);
  }) || 'Patient';
};
var getId = function getId(label) {
  return Sex[(0, _lodash.capitalize)(label)] || null;
};
var GenderUtils = {
  Sex: Sex,
  getLabel: getLabel,
  getId: getId
};
exports.GenderUtils = GenderUtils;